<div *ngIf="!memberData">
	<p class="font-weight-bold">Loyalty Member?</p>
	<p class="my-3">Enter your phone number to apply points from this order.</p>
	<form ngForm #fLoyalty="ngForm">
		<div class="p-fluid">
			<input type="tel" autocomplete="tel" required pInputText name="loyaltyPhone" [(ngModel)]="phoneNumber" phone="US" mask="(000) 000-0000" />

			<button type="button" class="btn btn-primary w-100 mt-3" (click)="processLoyalty(phoneNumber)" [ladda]="saving" [disabled]="fLoyalty.form.invalid">
				Submit
			</button>
		</div>
	</form>
</div>

<div *ngIf="memberData">
	<div class="p-grid">
		<div class="p-col">Hi {{ app.references.toTitleCase(memberData.FirstName) }} {{ app.references.toTitleCase(memberData.LastName) }}!</div>
	</div>
	<div *ngFor="let plan of memberData.Plan">
		<div class="p-grid">
			<div class="p-col">
				{{ plan.PlanName }}
			</div>
			<div class="p-col justify-content-end">{{ plan.PlanValue }} {{ plan.PlanMeasurement }}</div>
		</div>
	</div>
	<div class="d-flex justify-content-center">
		<fa-icon [icon]="['far', 'thumbs-up']" class="m-2"></fa-icon>
		<span class="m-2">
			<i>Thanks! Your points have been posted.</i>
		</span>
	</div>
</div>
